/**
 * angular constant定义错误码，提供给AUI注入，错误码整改前的配置也加进来了（nspError）
 * @date 2018/09/05
 */
define('constant/common/huawei-error-zh.constant',['app'], function (app) {
    var contractUs = window.sysUrlCfg.documentHref.contractUs;
    var contactWithCustomService = window.sysUrlCfg.documentHref.contactWithCustomService;

    var contactWithCS = '糟糕，当前应用不可自助认领，请<a class="text-link" target="_blank" href="' + contactWithCustomService + '">联系客服</a>，进行认领操作。';
    var contactS = '<a class="text-link" target="_blank" href="' + contractUs + '">联系客服</a>。';
    var contactSupport = '<a class="text-link" target="_blank" href="' + contractUs + '">联系客服</a>';


    app.constant('HuaweiError', {
        syserrorMsg: syserrorMsg,
        OpenOther: {
            "500": "操作返回数据不正确。",
            "90100000": syserrorMsg,
            "90105006": "查询放通名单列表信息失败。",
            "90113003": "参数校验失败。",
            "90120000": "用户不存在。",
            "90120001": "Http响应消息体大小超过限制。",
            "90120002": "Http连接异常。",
            "90120003": "Http网络IO异常。",
            "90120004": "报表响应消息异常。",
            "90120005": "文件压缩失败。",
            "90120006": "Http响应解析错误。",
            "90120007": "支付平台响应消息异常。",
            "90120008": "支付方式个数超过最大限制。",
            "90119639": "开发者角色为空。",
            "90100006": syserrorMsg,
            "90105004": "暂无相关数据",
            "90119615": syserrorMsg,
            "90102165": "已经超出协议约定时间，提交失败。",
            "90119621": "此应用当前已处于您的账户下，请勿重复认领。",
            "90100008": "您无权限进行当前操作。",
            "90119629": "您认领的应用正在审核中，请勿重复认领。",
            "90119627": "您认领的应用正在审核中，请勿重复认领。",
            "90119614": contactWithCS,
            "90119616": "当前应用无法认领，应用包已不存在。",
            "90119617": "此应用不可自动领取，请通过devconnect@huawei.com进行认领。",
            "90119607": syserrorMsg,
            "90119609": syserrorMsg,
            "90140019": syserrorMsg,
            "90100002": "文件上传至文件服务器失败。请稍后再试。",
            "90170017": "芝麻信用认证异常，请稍后重试。",
            "90100004": syserrorMsg,
            "90120009": "芝麻信用认证异常，请稍后重试。",
            "90103003": "芝麻信用认证异常，请稍后重试。",
            "90170026": "该身份证号已用户认证华为开发者联盟，请勿重复提交认证。",
            "90170012": "实名信息提交失败。",
            "90119640": syserrorMsg,
            "90119606": syserrorMsg,
            "90119204": "同一个应用7天内最多仅能发送一个任务，已保存草稿，请修改发送时间。",
            "90119214": syserrorMsg,
            "90119211": syserrorMsg,
            "90310006": syserrorMsg,
            "90119401": syserrorMsg,
            "90119402": syserrorMsg,
            "90119208": syserrorMsg,
            "90119209": syserrorMsg,
            "90119215": "未查到符合条件的用户，请修改发送时间或用户群类别。",
            "90119207": syserrorMsg,
            "90119101": syserrorMsg,
            "90112003": syserrorMsg,
            "90118008": syserrorMsg,
            "90118010": syserrorMsg,
            "90118011": syserrorMsg,
            "90118009": syserrorMsg,
            "90118012": syserrorMsg,
            "90119216": "任务开始时间不能早于当前时间，请修改后再提交。",
            "90119212": "提交审核失败，请稍后再试。",
            "90119652": '尊敬的开发者您好，您无权访问团队帐号。如有疑问请' + contactS,
            "90501007": syserrorMsg,
            "90100011": syserrorMsg,
            "90100012": syserrorMsg,
            "90100013": syserrorMsg,
            "90100014": syserrorMsg,
            "90100015": syserrorMsg,
            "90100016": syserrorMsg,
            "90100021": syserrorMsg,
            "90150015": syserrorMsg,
            "90150016": syserrorMsg,
            "90150025": syserrorMsg,
            "90150026": syserrorMsg,
            "90150027": syserrorMsg,
            "90150028": syserrorMsg,
            "90150029": syserrorMsg,
            "90150030": '尊敬的开发者您好，该套餐与您的已有套餐冲突，不可订购。如有疑问请' + contactS,
            "90150031": syserrorMsg,
            "90150032": syserrorMsg,
            "90150037": '尊敬的开发者您好，您订购的套餐数已达到最大限制，不可再订购。如有疑问请' + contactS,
            "90150038": syserrorMsg,
            "90150039": '尊敬的开发者您好，该套餐正在退订中，暂不允许操作。如有疑问请' + contactS,
            "90150040": syserrorMsg,
            "90150041": '尊敬的开发者您好，该套餐已设置自动续订不允许手动续订。如有疑问请' + contactS,
            "90150042": '订购关系不存在',
            "90150043": '订购关系已失效',
            "90150050": '尊敬的开发者您好，此订购已续订。如有疑问请' + contactS,
            "90150052": '尊敬的开发者您好，您已订购该套餐，此套餐不支持重复订购。如有疑问请' + contactS,
            "90119651": '尊敬的开发者您好，由于权限发生变化，请您退出当前帐号，重新登录。如有疑问请' + contactS,
            "90102001": "尊敬的开发者您好，您的开发者信息在审核中，请审核通过后再继续当前操作",
            "90118056": "待转移的应用存在不可转移的服务，不能接收转移，如需帮助请" + contactS,
            "90101067": "您实名认证所在的国家和转出开发者所在的国家不一致，不能接收转移，如需帮助请" + contactS,
            "90101079": "您未签署相关的服务协议，不能接收转移，如需帮助请" + contactS,
            "90118038": "当前应用正在认领中，不能转移，如需帮助请" + contactS,
            "90119618": "您认领的应用暂不支持认领，如需帮助请" + contactS,
            "90101082": "商户未开通，如需帮助请" + contactS,
            "90102029": "用户未实名认证通过，如需帮助请" + contactS,
            "90118007": "开发者帐号当前被停用，如需帮助请" + contactS,
            "90102059": "您认领的应用涉及运营活动，暂不支持认领，如需帮助请" + contactS,
            "70007424": "您当前邀请的帐号为儿童帐号，无法被邀请。",
            "90150060": "您当前项目上该隐私角色的联系人已经添加，请勿重复添加。",
            "90150061": "当前用户不支持应用转移，如需帮助请" + contactS,
            "90102182": "当前用户不支持应用转移，如需帮助请" + contactS,
        },
        openOtherDelegate: {
            "90118007": "当前帐号已经停用。",
            "90119640": "鉴权失败。",
            "90100006": "参数异常。",
            "90119646": "prmcode或srmcode为空。",
            "90119650": "申请结算必须完善商户信息，请核实商户服务中的银行信息，税务信息，联系人信息是否已经填写。"
        },
        openGw: {
            "1": "一个未知的错误发生。",
            "2": "服务临时不可用。",
            "3": "未知的方法。",
            "4": "应用已达到设定的请求上限。",
            "5": "请求来自未经授权的IP地址。",
            "6": "当前用户session key过期了。",
            "7": "调用次数超过了限制。",
            "8": "调用过于频繁。",
            "100": "无效未知参数。",
            "101": "无效的API_KEY。",
            "102": "无效的SESSION_KEY。",
            "103": "必须是POST提交。",
            "104": "无效的签名。",
            "105": "缺少系统参数：如nsp_svc, nsp_ts, nsp_key等。",
            "106": "app或者session没有调用当前服务的权限。",
            "107": "client和secret需要重新获取（如算法升级等）。",
            "108": "路由失败，无法识别服务投递地址。",
            "109": "nsp_ts偏差过大。",
            "110": "接口内部异常。",
            "111": "服务繁忙。",
            "403": "无权限。"
        },
        openAgreement: {
            "90181001": "系统内部错误。",
            "90181002": "参数错误。",
            "90181003": "未找到协议版本。",
            "90181004": "该协议无此语种。",
            "90181005": "协议类型不存在。",
            "90181007": "拒绝访问。",
            "90181008": "无签署记录。",
            "90181009": "签名校验失败。",
            "90181010": "该国家协议未版本化。"
        },
        openUP: {
            "70001201": syserrorMsg,
            "70002067": "已经超过了最大联系人的数目，无法新增。",
            "70001226": "请输入正确的邮箱地址。",
            "70001227": "请输入正确的手机号。",
            "70001402": syserrorMsg,
            "70001401": syserrorMsg,
            "70001235": "您提交的发票抬头与实名认证的企业名称字段不一致。请检查并重新录入。",
            "70001230": "请输入的正确的注册电话。",
            "70002068": "当前联系人信息正在被使用，无法删除。",
            "70001232": "当前联系人信息已经被删除。",
            "70001225": "文件格式不正确，文件上传失败。请参考界面提示重新上传。",
            "70003001": syserrorMsg,
            "70003002": syserrorMsg,
            "70003003": syserrorMsg,
            "70005004": "您当前正处于实名审核中，无法提交实名信息变更。",
            "70005013": "您当前正处于名称变更审核中。无法提交实名或银行信息变更。",
            "70006012": "您当前正处于实名审核中，无法提交实名信息变更。",
            "70015003": "您提交的Duns Number已经被使用，请重新获取并提交实名信息。",
            "70001228": "请选择正确的省份。",
            "70001229": "请选择正确的城市。",
            "70001231": "实名认证类型选择错误，请重新提交实名信息。",
            "70002035": "您的银行信息正处于审核中，无法提交变更。",
            "70007301": "您维护了外币收款账户，请维护Swift Code。",
            "70005009": "商户信息更新失败，请选择正确的开户银行信息。",
            "70005010": "商户信息更新失败，请选择正确的开户行支行信息。",
            "70001233": "银行信息更新失败。",
            "70001234": "税务信息更新失败。",
            "70007303": "银行名与银行号不对应。",
            "70007304": "支行名与支行号不对应。",
            "70002043": syserrorMsg,
            "70005037": "系统未能校验到您的企业信息，请" + contactSupport + "处理。",
            "70005025": "您输入的企业名称与营业执照号不匹配，请您重新输入。",
            "70005022": "已完成实名认证，不允许提交银行打款实名认证。",
            "70005023": "达到系统允许银行打款认证最大次数限制，不允许再次提交。",
            "70005024": "您的企业认证帐号数超过系统限制，如有疑问请" + contactS,
            "70005026": "该企业没有采用银行打款实名认证，不允许提交金额认证。",
            "70005027": "该企业没有银行打款实名认证记录，不允许提交金额认证。",
            "70005028": "该企业没有银行打款实名认证记录，不允许提交金额认证。",
            "70005029": "银行打款失败，请稍后提交金额认证。",
            "70005030": "银行打款确认中，请稍后提交金额认证。",
            "70005031": "银行打款失败，无法进行金额校验。",
            "70005032": "已完成打款金额校验，请勿重复提交。",
            "70005033": "银行打款认证已过期，实名认证失败。",
            "70005034": "银行打款结果确认异常，请稍后提交金额认证。",
            "70001253": '您的帐号已被识别为儿童帐号，不满足华为开发者联盟提供服务的年龄要求，无法使用相关服务，如有疑问请' + contactS,
            "70005041": "您提交的实名认证审核已完成，不支持撤销，请刷新页面查看认证结果",
            "70005042": "您选择的认证方式不支持撤销，请耐心等待认证结果",
            "70005043": "您的角色切换申请正在审核中，不支持撤销，请耐心等待",
            "70005044": "您的更名申请正在审核中，不支持撤销，请耐心等待",
            "70005054": "您的人工认证转其他认证，不支持撤销，请耐心等待",
            "70005062": "您的企业存在暂停帐号无法使用打款认证服务，如有疑问请" + contactS,
            "70007500": syserrorMsg,
            "70007501": syserrorMsg,
            "70007421": "成员帐号权限到期日期已过，无法接受邀请",
            "70007560": "您的银行卡状态异常，暂不支持认证，请联系对应银行咨询",
            "70005057": "您提交的实名认证审核已完成，不支持切换用户类型。",
            "70005060": "尊敬的开发者您好，您的帐号已经开通多种服务，不允许切换用户类型。如有疑问请" + contactS,
            "70005063": "您提交的银行帐号使用次数超过系统限制，如有疑问请" + contactS,
            "70001252": "您帐号认证类型的切换次数已达今日上限，如需切换认证类型，请于次日操作。",
            "70005074": "您不满足华为开发者联盟提供服务的年龄要求，无法使用相关服务，暂不予认证"
        },
        CardAuth: {
            "70001253": '尊敬的开发者您好，您不满足华为开发者联盟提供服务的年龄要求，无法使用相关服务，暂不予认证',
            "70007502": "该身份证号用户已认证华为开发者联盟，请勿重复提交认证",
            "70007503": "您提交的银行卡认证次数已达当日上限，请24小时后重新提交认证，或选择人工审核方式重新认证",
            "70007504": "您使用同一身份证号提交的银行卡认证次数已达当日上限，请24小时后重新提交认证",
            "70007505": "尊敬的开发者，当前操作遇到异常无法完成，如需帮助请",
            "70007561": "您输入的银行卡号无效，请核对后重新输入",
            "70007563": "您的银行卡状态异常，暂不支持银行卡认证，请联系开户行银行咨询",
            "70007566": "银行卡持有者的身份证信息或银行卡绑定的手机号输入不正确，验证失败",
            "70007568": "您的银行卡暂不支持银行卡认证，请向开户行银行或拨打95516咨询",
            "70007560": "您的银行卡状态异常，暂不支持认证，请联系对应银行咨询",
            "70001256": "您的银行卡名称不正确，请联系对应银行咨询",
            "70005074": "您不满足华为开发者联盟提供服务的年龄要求，无法使用相关服务，暂不予认证",
            "70003015": "系统检测到您的帐号异常，不支持银行卡认证方式认证，请PC端通过人工审核方式进行实名认证",
            "70009060": "您的银行卡卡号的认证错误次数已达当日上限，请次日再试",
            "70009061": "您的证件实名认证受限，如需帮助请",
            "70009022": "您输入的卡号的字符长度不正确，请输入正确的卡号",
            "70009025": "您的银行卡号无效，请输入正确的银行卡号",
            "70009028": "您的银行卡已过期，请联系发卡行",
            "70009031": "您的银行卡暂未开通银联在线支付功能，无法认证，请联系发卡行",
            "70009034": "您的银行卡受限制,请联系发卡行",
            "70009041": "您的银行卡核验信息填写不正确，请输入正确的信息",

        },
        HispaceUC: {},
        openpush: {},
        OpenGame: {},
        Higame: {},
        OpenMessage: {
            90320002: "验证码已过期,请重新获取。",
            90320003: "验证码错误。",
            90320004: "验证码验证失败次数过多",
            90320005: "验证码已经超出一天内最大验证次数限制",
            90320006: "已经超过同一个联系方式验证码获取次数限制，请一小时后再试。",
            90320007: "已经超过同一个联系方式验证码获取次数限制，请24小时后重试。",
            90320008: "已经超过验证码获取次数限制，请一小时后再试",
            90320009: "已经超过验证码获取次数限制，请24小时后再试",
            90300001: syserrorMsg,
            90300002: syserrorMsg,
            90310001: "邮箱格式错误",
            90310000: syserrorMsg,
            90300003: syserrorMsg
        },
        hms: {},
        theme: {},
        openApp: {
            "90210003": syserrorMsg,
            "90200201": "操作失败，您所操作的记录已经失效或者已删除。",
            "90200503": "该应用下有效的APK数量超限，无法继续上传，如需继续上传APK，请清理APK包。",
            "90200021": "上传APK文件失败，请稍后重试。",
            "90200106": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200615": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200120": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200617": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200601": "该应用下有效的RPK数量超限，无法继续上传，如需继续上传RPK，请清理RPK包。",
            "90200602": "上传RPK文件失败，请稍后重试。",
            "90202109": "RPK中的卡片信息不符合免安装应用规范要求，请修改后重新上传。",
            "90200603": "RPK中的包名不符合免安装应用规范要求，请修改后重新上传。",
            "90200604": "RPK中的中文名称不符合免安装应用规范要求，请修改后重新上传。",
            "90200605": "RPK中的versionCode不符合免安装应用规范要求，请修改后重新上传。",
            "90200606": "RPK中的versionNumber不符合免安装应用规范要求，请修改后重新上传。",
            "90200607": "RPK包大小超过10M，请重新上传。",
            "90200613": "RPK图标不正确，请对照规范修改后重新提交。",
            "90200609": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200608": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200003": "产品信息不完整，请完善后重新提交。",
            "90200007": "记录已存在。",
            "90208012": "服务存在依赖关系，操作失败。",
            "90208013": "服务添加失败，只有应用可以添加云文件夹和预装服务。",
            "90208016": "您无权限进行当前操作。",
            "90208014": "服务只有草稿态或已下架状态可以被删除。",
            "90208015": "服务存在依赖关系，操作失败。",
            "90210024": "系统已经存在该测试BundleId。",
            "90210025": "测试BundleId已配置，不可修改。",
            "90210023": "BundleId已配置，不可修改。",
            "90200001": syserrorMsg,
            "90200009": syserrorMsg,
            "90200010": syserrorMsg,
            // "90200001":'您填写的内容格式不正确，请重新填写',
            "90210022": '系统已经存在该BundleId',
            "90200002": "您无权限进行当前操作。",
            "90209015": "当前保存的APK包不存在，提交上架失败。",
            "90200614": "非法参数，提交失败。",
            "90200022": "APK包的中文名称与应用的中文名称不一致，请修改一致后再提交APK包。",
            "90200000": syserrorMsg,
            "90208003": "当前服务状态不允许进行此操作。",
            "90208011": "您的服务信息或产品信息均未变更，提交审核失败。",
            "90200008": "该应用正在转移中，请稍候操作。",
            "90200612": syserrorMsg,
            "90209005": '主题包中解析出的主题中文名称不正确',
            "90209016": '主题包中解析出的主题英文名称不正确',
            "90210014": "产品名在系统中已存在，请修改后重新提交。",
            "90204001": "动态壁纸名称在系统中已存在，请修改后重新提交。",
            "90204002": "一个动态壁纸下有效的APK包数量不能超过30个，请删除无效APK包后再提交APK包。",
            "90200119": "包名不符合APK包规范，请修改后重新提交APK包。",
            "90204003": "动态壁纸包名在系统中已存在，请修改后重新提交。",
            "90204005": "动态壁纸包名在系统中已存在，请修改后重新提交。",
            "90204004": "动态壁纸包名在系统中已存在，请修改后重新提交。",
            "90200109": "该包名的应用已经存在，请更换包名，如有疑问，请" + contactS,
            "90200616": "该包名的应用已经存在，请更换包名，如有疑问，请" + contactS,
            "90200618": "该包名的应用已经存在，请更换包名，如有疑问，请" + contactS,
            "90210016": "一个字体下有效的包数量不能超过30个，请删除无效字体包后再重新提交。",
            "90210017": "ttf文件名在系统中已存在，请修改后重新提交。",
            "90210018": "ttf文件名需要跟产品下其他字体包的ttf文件名保持一致，请修改后重新提交。",
            "90200019": "字体包解析失败，请修改后重新提交。",
            "90204006": "动态壁纸包大小超出限制，请修改后重新提交。",
            "90200030": "同一个主题产品下的主题包的中文名称、设计师、版本号前两个数字需要保持一致，请修改后重新提交。",
            "90200108": syserrorMsg,
            "90200040": syserrorMsg,
            "90210015": syserrorMsg,
            "90200629": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200630": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200020": "该名称和版本号的主题在系统中已经存在，请修改后重新提交。",
            "90200508": "创建应用超过限制条数,请删除不必要的应用后重试。",
            "77720007": "字体包文件名或字体包内文件校验失败，请按照规范重新提交。",
            "77720008": "字体包内预览图文件数量不能少于4个，请修改后重新提交。",
            "77720009": "字体包内缺少ttf文件，请修改后重新提交。",
            "77720010": "字体包内只能有一个ttf文件，请修改后重新提交。",
            "77720011": "字体包文件大小超出最大限制，请修改后重新提交。",
            "90200202": "APK包名需要跟产品下其他APK包名保持一致，请修改后重新提交。",
            "77720012": "产品包解压后超过最大值的限制，请修改后重新提交。",
            "70001211": "您上传的文件大小总量已达上限，请3小时后重试。",
            "90210058": "凭证已绑定APP ID，无法删除。",
            "90102182": "当前用户不支持应用转移，如需帮助请" + contactS,
        },
        openPush: {
            "80300002": "应用不存在，请选择已有应用重新操作。",
            "80300008": "证书错误，请修改后重新提交。",
            "80300009": "操作码不能为空。",
            "80300010": "回调地址不能为空。",
            "80300011": "回调地址长度不能超过255，请修改后重新提交。",
            "80300012": "HTTPS证书不能为空。",
            "80300013": "测试回调地址失败。",
            "80500001": syserrorMsg//处理失败
        },
        OpenTrade: {
            'success': 0,
            //'数据库操作异常',
            "88800004": syserrorMsg,
            //'参数不合法',
            "88800010": syserrorMsg,
            //'与SAP间通信异常（网关异常）',
            "88800012": syserrorMsg,
            //'从FS下载文件异常',
            "88800011": syserrorMsg,
            //'响应消息体非法',
            "88800013": syserrorMsg,
            //'上传文件至FS异常',
            "88800014": syserrorMsg,
            //'压缩本地文件异常',
            "88800015": syserrorMsg,
            //'生成本地文件异常',
            "88800016": syserrorMsg,
            //'与EDM间通信异常（网关异常）',
            "88800017": syserrorMsg,
            //'EDM响应消息体非法',
            "88820001": syserrorMsg,
            //'从Developer查询用户信息失败',
            "88820008": syserrorMsg,
            //'FS路径转换异常',
            "88820017": '当前订单状态不支持此操作，如需帮助请联系我们。',
            //'订单不存在',
            "88820023": '待划转的金额不能超过当前余额。',
            //'划转金额大于余额',
            "88820104": syserrorMsg,
            //'重复请求',
            "88820235": syserrorMsg,
            //'账户扩展信息（币种）不存在',
            "88820236": syserrorMsg,
            //'账户扩展信息（币种）已存在',
            "88820030": '当前合同信息异常，无法进行此操作。',//'合同信息不存在'
            '88820002': '订单号不存在。',
            '88820260': '失效订单号不唯一。',
            "88820026": '申请退款金额不能大于现金账户余额。',
            '88820267': '申请退款金额不能大于充值订单余额。',
            '88800001': syserrorMsg,
            '88800002': syserrorMsg,
        },
        nspError: { // 错误码整改之前的错误码映射合集，当前面的映射都找不到错误码时，最后在这里找
            90200011: '创建应用超过周限制条数',
            90202201: '主题包解析错误',
            90202202: '主题包解析失败，主题包缺失cover.jpg文件',
            90202501: '上传主题相关信息必须相同（中文名称+终端版本+终端分辨率）',
            90202502: '低于已激活版本',
            90205001: '转移与被转移不能是同一个人',
            90208001: '无权限删除凭证，因为产品下还有未删除的服务',
            90209001: 'APK中解析出的包名不正确',
            90209002: 'APK中解析出的显示版本不正确',
            90209003: 'APK中解析出的支持分辨率类型不正确',
            90209004: '主题包中解析出的OS版本不正确',
            90209005: '主题包中解析出的主题中文名称不正确',
            90209016: '主题包中解析出的主题英文名称不正确',
            90209006: '主题包中解析出的支持分辨率不正确',
            90209007: '主题包中解析出的设计者名称不正确',
            90209008: '主题包中解析出的作者名称不正确',
            90209009: '主题包中解析出的主题简介不正确',
            90209010: '主题包中解析出的主题字体不正确',
            90209011: '主题包中解析出的缩略图不正确',
            90119617: '此应用不可自动领取，请通过devconnect@huawei.com进行认领。',
            90119620: '此应用不可自动领取，请通过devconnect@huawei.com进行认领。',
            90119621: '此应用当前已处于您的账户下，请勿重复认领。',
            90119614: '您认领的应用正在处理中，请勿重复认领。',
            90119629: '您认领的应用正在审核中，请勿重复认领。',
            90119627: '您认领的此应用正在审核中，请勿重复认领。',
            90119643: '您认领的此应用正在审核中，暂时不能被认领，请耐心等待。',
            '90209017': 'APK包中设置的权限列表超过最大长度20000个字符限制，请修改后重新提交APK包',
            80100001: '找不到UserID',
            80500001: syserrorMsg,
            80200001: "输入参数不合法。",
            80200009: "证书不合法。",
            80200010: "证书必须是P12格式文件。",
            80200011: "开发证书密码错误。",
            80200012: "生产证书密码错误。",
            80200013: "该证书已经被其他应用绑定。",
            80200014: "证书保存失败。",
            80200020: '应用包名已被占用',
            80300002: "应用不存在。",
            80300005: "应用ID未绑定到用户上。",
            90118012: '生成zip包超过最大100K限制',
            80200003: '输入参数不合法。',
            80200004: 'Token非法。',
            80300006: '免费Push服务未启用。',
            80300008: '该应用未开启iOS Push。',
            90209012: '该产品下的可用主题包已超过上限。',
            90209013: '该产品下的可用壁纸包已超过上限。',
            "defaultInfo": "请求失败，请稍候重试。",
            70002068: "删除失败，该联系方式已被使用。",
            90200107: "应用包名不存在",
            90200119: "包名不符合APK包规范，请修改后重新提交APK包",
            90205003: "待审核的云文件夹应用不存在",
            "90209014": "APK中的中文名不正确,中文名长度要在1到64之间",
            90200501: "转移app不能转移给自己",
            90200502: "当前应用状态不能被转移",
            70002067: "您的请求在1小时内已超出限制",
            90119642: "您未签署最新版本的付费协议，无法充值。",
            "70002039": "验证码无效。",
            "70002058": "短信验证码失败次数过多，请稍后重试。",
            "70002057": "短信验证码失败次数过多，请稍后重试。",
            90119644: "请重新签署商户服务协议或应用市场联运服务协议。",
            90100008: "您无权限进行当前操作",
            90200611: "产品类型不是免安装应用，不能使用RPK包",
            90202101: "尊敬的开发者，当前操作遇到异常无法完成，如需帮助请联系我们。",
            90202102: "RPK包大小超过10M",
            90202103: "RPK包格式错误，无法解析, 请对照规范修改后提交",
            90202104: "RPK Manifest文件缺失，请对照规范修改后提交",
            90202105: "RPK图标文件缺失，请对照规范修改后提交",
            90202106: "RPK包中的Manifest文件缺少必须字段，请对照规范修改后提交",
            90202107: "RPK包中的Manifest文件总行数超过限制，请修改后提交",
            90202108: "RPK包中的Manifest文件单行字符数超过限制，请修改后提交",
            90202110: "RPK卡片ID重复",
            90208024: "RPK存在已关联的快服务，不允许下架。",
            90202117: "应用市场服务不存在或状态异常",
            90202118: "快服务名称重复",
            70007301: "您维护了外币收款账户，请维护银行国际代码",
            90119640: syserrorMsg,
            "90210003": syserrorMsg,
            "90200201": "操作失败，您所操作的记录已经失效或者已删除。",
            "90200503": "该应用下有效的APK数量超限，无法继续上传，如需继续上传APK，请清理APK包。",
            "90200021": "上传APK文件失败，请稍后重试。",
            "90200106": "包名已存在，请更换包名，如有疑问，请联系客服。",
            "90200615": "包名已存在，请更换包名，如有疑问，请联系客服。",
            "90200202": "APK包名需要与应用下已提交的包名一致,请修改一致后重新提交APK包",
            "90200601": "该应用下有效的RPK数量超限，无法继续上传，如需继续上传RPK，请清理RPK包",
            "90200602": "上传RPK文件失败，请稍后重试。",
            "90202109": "RPK中的卡片信息不符合免安装应用规范要求，请修改后重新上传",
            "90200603": "RPK中的包名不符合免安装应用规范要求，请修改后重新上传",
            "90200604": "RPK中的中文名称不符合免安装应用规范要求，请修改后重新上传",
            "90200605": "RPK中的versionCode不符合免安装应用规范要求，请修改后重新上传。",
            "90200606": "RPK中的versionNumber不符合免安装应用规范要求，请修改后重新上传。",
            "90200607": "RPK包大小超过10M，请重新上传。",
            "90200613": "RPK图标不正确，请对照规范修改后重新提交。",
            "90200609": "包名已存在，请更换包名，如有疑问，请联系客服。",
            "90200608": "包名已存在，请更换包名，如有疑问，请联系客服。",
            "90200610": "RPK包名需要与应用下已提交的包名一致,请修改一致后重新提交RPK包",
            "90200003": "产品信息不完整，请完善后重新提交。",
            "90200007": "记录已存在",
            "90208012": "服务存在依赖关系，操作失败。",
            "90208013": "服务添加失败，只有应用可以添加云文件夹和预装服务。",
            "90208014": "服务只有草稿态或已下架状态可以被删除。",
            "90200001": syserrorMsg,
            "90200009": syserrorMsg,
            "90200010": syserrorMsg,
            "90200002": "您无权限进行当前操作。",
            "90209015": "当前保存的APK包不存在，提交上架失败。",
            "90200614": "非法参数，提交失败。",
            "90200022": "APK包的中文名称与应用的中文名称不一致，请修改一致后再提交APK包。",
            "90200000": syserrorMsg,
            "90208003": "当前服务状态不允许进行此操作。",
            "90208011": "您的服务信息或产品信息均未变更，提交审核失败。",
            "90200008": "该应用正在转移中，请稍候操作。",
            "90200612": syserrorMsg,
            "90100006": syserrorMsg,
            "90105004": syserrorMsg,
            "90119606": syserrorMsg,
            "90119615": syserrorMsg,
            "90119616": "当前应用无法认领，应用包已不存在。",
            "90119607": syserrorMsg,
            "90119609": syserrorMsg,
            "90140019": syserrorMsg,
            "90100002": "文件上传至文件服务器失败。请稍后再试。",
            "90170017": "芝麻信用认证异常，请稍后重试。",
            "90170026": "该身份证号已用户认证华为开发者联盟，请勿重复提交认证。",
            "90100004": syserrorMsg,
            "90120009": "芝麻信用认证异常，请稍后重试。",
            "90103003": "芝麻信用认证异常，请稍后重试。",
            "90170012": "实名信息提交失败。",
            "90204002": '上传动态壁纸包超过30个',
            "90210026": "该包已经存在，不需要再重新上传",
            77700004: "从云存储平台下载文件失败异常",
            77700005: "下载文件IO异常",
            70001201: syserrorMsg,
            77700002: "从NSP获取响应流失败",
            77700003: "从OBS获取响应流失败",
            70002111: "url超时",
            70001204: "authcode和文件名生成失败，抛出请求上传失败",
            70004000: "删除文件失败，文件不属于该用户",
            70002115: "APK包中AndroidManifest.xml行数超过限制的大小，请修改后重新提交APK包",
            70002116: "APK包中AndroidManifest.xml单行长度超过限制的大小，请修改后重新提交APK包",
            70002118: "AndroidManifest.xml文件中package定义不符合规范，请修改后重新提交APK包",
            70002117: "AndroidManifest.xml文件中的icon为空，请补充后重新提交APK包",
            70002119: "AndroidManifest.xml文件中的sdkVersion定义不符合规范，请修改后重新提交APK包",
            70002120: "AndroidManifest.xml文件中的application定义不符合规范，请修改后重新提交APK包",
            70002103: "rpk包格式错误，无法解析",
            70002102: "rpk文件大小超出限制",
            70002104: "rpk Manifest文件缺失",
            70002107: "rpk Manifest文件总行数超过限制",
            70002108: "rpk Manifest文件单行字符数超过限制",
            70002106: "rpk Manifest文件缺少必需字段",
            70002105: "rpk 应用图标文件缺失",
            "70001211": "您上传的文件大小总量已达上限，请3小时后重试。",
            "70005062": "您的企业存在暂停帐号无法使用打款认证服务，如有疑问请" + contactS,
            90320002: "验证码已过期,请重新获取。",
            90320004: "验证码验证失败次数过多",
            90320003: "验证码错误。",
            90320005: "验证码已经超出一天内最大验证次数限制",
            90320007: "已经超过同一个联系方式验证码获取次数限制，请24小时后重试。",
            90320006: "已经超过同一个联系方式验证码获取次数限制，请一小时后再试。",
            90320009: "已经超过验证码获取次数限制，请24小时后再试",
            90320008: "已经超过验证码获取次数限制，请一小时后再试",
            90300001: syserrorMsg,
            90310001: "邮箱格式错误",
            90300002: syserrorMsg,
            90310000: syserrorMsg,
            90300003: syserrorMsg,
            // 团队帐号 通用错误码
            //一般不会出来
            70007400: "团队帐号异常，暂不支持更多操作，如有疑问请" + contactS,
            70007401: "团队帐号异常，暂不支持更多操作，如有疑问请" + contactS,
            70007402: "您添加的成员帐号数已达到最大限制，请删除无用帐号再添加。",
            70007403: "您不可以添加自己为成员帐号",
            70007404: "该成员帐号已添加，不可重复添加",
            70007405: "您向该成员发送的邀请次数，已达到24小时最大限制，请24小时后再重新邀请。",
            70007406: "当前操作的成员帐号不存在",
            70007407: "您邀请成员帐号的总次数，已达到每天的最大限制，请改天再邀请。",
            70007408: "成员帐号还未注册UP帐号",
            70007409: "您登录的帐号与被邀请帐号不一致，激活失败。如有疑问请" + contactS,
            70007410: "成员帐号激活失败！接受邀请时间超过激活有效期，请您联系帐号持有者重新邀请。",
            70007411: "该成员加入的团队帐号数，已达到最大限制，无法接收邀请。",
            70007412: "您已成功激活该成员帐号，无需重复激活。如有疑问请" + contactS,
            70007413: "当前成员帐号无效，如：格式不正确等",
            70007414: "成员帐号激活失败！请您联系帐号持有者重新邀请。",
            70007415: "成员已销户",
            90700000: syserrorMsg,
            90710000: syserrorMsg,
            90711010: syserrorMsg,
            90711011: syserrorMsg,
            90711012: syserrorMsg,
            90711050: syserrorMsg,
            90711051: syserrorMsg,
            90711052: syserrorMsg,
            90711053: syserrorMsg,
            90102139: "您当前的权限无法修改该成员，请联系帐号持有者修改",
            90711054: "您尚未通过实名认证，无法使用该服务，请您先完成实名认证。",
            90711055: syserrorMsg,
            90711058: syserrorMsg,
            90711060: syserrorMsg,
            90711062: "您的团队帐号信息为空，如有疑问请" + contactS,
            90700008: "未查询到该团队帐号相关记录，如有疑问请" + contactS,
            90700007: "您尚未开通此项权限，如有疑问请" + contactS,
            90700006: "您尚未开通此项权限，如有疑问请" + contactS,
            90700005: syserrorMsg,
            90700004: syserrorMsg,
            90720025: syserrorMsg,
            90720024: "您无权限修改，请联系帐号持有者修改。",
            90700002: syserrorMsg,
            90720036: syserrorMsg,
            70007416: "您已成为该团队帐号的成员，不能再邀请该帐号加入您的团队，如需帮助请" + contactS,
            90119651: '尊敬的开发者您好，由于权限发生变化，请您退出当前帐号，重新登录。如有疑问请' + contactS,
            "90102001": "尊敬的开发者您好，您的开发者信息在审核中，请审核通过后再继续当前操作",
            "90200508": "创建应用超过限制条数,请删除不必要的应用后重试。",
            "90118056": "待转移的应用存在不可转移的服务，不能接收转移，如需帮助请" + contactS,
            "90101067": "您实名认证所在的国家/地区和转出开发者所在的国家/地区不一致，不能接收转移，如需帮助请" + contactS,
            "90101079": "您未签署相关的服务协议，不能接收转移，如需帮助请" + contactS,
            "90118038": "当前应用正在认领中，不能转移，如需帮助请" + contactS,
            "90101065": "只支持开发者类角色转移，如需帮助请" + contactS,
            "90119618": "您认领的应用暂不支持认领，如需帮助请" + contactS,
            "90119619": "您认领的应用暂不支持认领，如需帮助请" + contactS,
            70007419: "您登录的帐号与被邀请帐号不一致，激活失败。请您退出当前帐号，点击邀请邮件里的激活链接登录被邀请帐号激活。如有疑问请" + contactS,
            "70007421": "成员帐号权限到期日期已过，无法接受邀请",
            "90210035": "您的创建的项目已经超出配额",
            "90210036": "项目别名已经存在",
            "90210037": "项目不存在",
            "90210038": "该api已经被添加",
            "90210039": "API不存在",
            "90210040": syserrorMsg,
            "90220001": syserrorMsg,
            "90220002": "api秘钥创建失败，如需帮助请" + contactS,
            "90220003": "服务帐号创建失败，如需帮助请" + contactS,
            "90220004": "api秘钥创建失败，如需帮助请" + contactS,
            "90220005": "服务帐号已存在，如需帮助请" + contactS,
            "90220006": syserrorMsg,
            "90220007": "服务帐号状态删除失败，如需帮助请" + contactS,
            "90220008": "服务帐号状态更新失败，如需帮助请" + contactS,
            "90220009": "clientID不存在，如需帮助请" + contactS,
            "90220010": "凭证总数超过限额，如需帮助请" + contactS,
            "90210007": "产品不存在",
            "90200617": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90220011": "服务帐号公钥超过限额，如需帮助请" + contactS,
            "90210041": "当前应用含有分发服务不能删除，如需帮助请" + contactS,
            "Api90210024": "凭证已经创建成功，但系统已经存在该测试BundleId",
            "Api90210022": "凭证已经创建成功，但系统已经存在该BundleId",
            "Api90200106": "凭证已经创建成功，但包名已存在，请更换包名，如有疑问，请" + contactS,
            "Api90200615": "凭证已经创建成功，但包名已存在，请更换包名，如有疑问，请" + contactS,
            "Api90200120": "凭证已经创建成功，但包名已存在，请更换包名，如有疑问，请" + contactS,
            "Api90200617": "凭证已经创建成功，但包名已存在，请更换包名，如有疑问，请" + contactS,
            "Api90200609": "凭证已经创建成功，但包名已存在，请更换包名，如有疑问，请" + contactS,
            "Api90200618": "凭证已经创建成功，但包名已存在，请更换包名，如有疑问，请" + contactS,
            "Api90200608": "凭证已经创建成功，但包名已存在，请更换包名，如有疑问，请" + contactS,
            "90220012": "该项目下存在凭证数据不能删除，如需帮助请" + contactS,
            "70007560": "您的银行卡状态异常，暂不支持认证，请联系对应银行咨询",
            "90200629": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200630": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90102059": "您认领的应用涉及运营活动，暂不支持认领，如需帮助请" + contactS,
            "70007424": "您当前邀请的帐号为儿童帐号，无法被邀请。",
            "90150060": "此项目的DPO已存在，请勿重复添加。",
            "90150061": "此项目的代表人已存在，请勿重复添加。",
            "70005074": "您不满足华为开发者联盟提供服务的年龄要求，无法使用相关服务，暂不予认证。",
            "90210058": "凭证已绑定APP ID，无法删除。",
            "90102182": "当前用户不支持应用转移，如需帮助请" + contactS,
            "700074281": "您企业的法定代表人信息未能校验通过，且校验次数已达上限，点击\"确定\"将跳转到人工审核认证方式页面，或" + contactSupport + "处理。",
            "700074282": "您企业的法定代表人信息未能校验通过，且校验次数已达上限，如有疑问，请" + contactS,
            "70007431": "系统未能校验到您企业的法定代表人信息，您还剩余n次法人身份验证,如有疑问，请" + contactS + "处理",
            "70007430": syserrorMsg,
            "700074283": "您企业的法定代表人信息未能校验通过，且校验次数已达上限，如有疑问，请" + contactSupport + "处理",
            "429": '系统繁忙，请过一段时间重试',
            "70005083": "实名认证撤销失败，请" + contactSupport + "处理。",
            "70005085": "请确认您是在Québec一般注册机制下注册还是Québec特殊注册机制下注册，通常您只能选择一种。",
            "70005084": "请确认您是在GST/HST普通注册机制下注册还是简易注册机制下注册，通常您只能选择一种。",
            "90200120": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200616": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200618": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200619": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200620": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200621": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200622": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200623": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200624": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200625": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200626": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200627": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90200628": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90204003": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90204004": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "90204005": "包名已存在，请更换包名，如有疑问，请" + contactS,
            "88820315": "您当前属于子客，不能直接充值，如有疑问，请" + contactS,
            "70009007": "该手机号码当前不支持在运营商侧做验证，请更换手机号码后重试。",
            "70009004": "您提交的联系信息验证次数已达到上限，请24小时后再提交。",
            "70009005": "您填写的联系人姓名、联系人身份证号和联系人手机信息不匹配，请检查后重新提交。",
            "7000900713": "该手机号码当前不支持在运营商侧做验证，请下次登录时更新联系信息。",
            "7000900413": "您提交的联系信息验证次数已达到上限，且失败次数过多，请下次登录时更新联系信息。",
            "7000900513": "您填写的联系人姓名、联系人身份证号和联系人手机信息不匹配，且失败次数过多，请下次登录时更新联系信息。",
            "88820277": "您当前的订单暂时无法开票，预计充值成功2天后可开票，请您耐心等待。",
            "88820279": "您当前的订单开票已超过开票有效期，无法开票。",
            "88820321": "您当前的订单重发发票请求已提交成功，请您耐心等待，如有需要请稍后重新申请。",
            "90102230": "您当前订单的单日申请次数已达到上限，如有需要请24小时后重新申请。"
        },
        HispaceStore: {}
    });
});

